// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mk-1";
export var spinner = "_mk-0";